import React, { useMemo, useState } from "react";
import clsx from "clsx";

import {
  AnswersByStudent,
  IClass,
  IGroup,
  OnePagePortfolioAssessmentAnswersByClass,
  OnePagePortfolioAssessmentAnswersFromOtherSchoolByClass,
} from "../../../state";
import ModalEditGroupClass from "../ModalEditGroupClass";

import styles from "./BAWorkAnswerList.module.scss";
import ClassAnswers from "./AnswerListType/ClassAnswers";
import GroupAnswers from "./AnswerListType/GroupAnswers";
import OtherSchoolAnswers from "./AnswerListType/OtherSchoolAnswers";

interface Props {
  answersByClasses: OnePagePortfolioAssessmentAnswersByClass[];
  answersOtherSchoolsByClasses: OnePagePortfolioAssessmentAnswersFromOtherSchoolByClass[];
  classes: IClass[];
  classList: number[];
  groups: IGroup[];
  changeNameOpenClose: (class_id: number, opened: boolean) => void;
}

const BAWorkAnswerList = ({
  classList,
  classes,
  answersByClasses,
  groups,
  answersOtherSchoolsByClasses,
  changeNameOpenClose,
}: Props) => {
  const [showModalEditGroupClass, setShowModalEditGroupClass] = useState(false);

  const answersByStudents: AnswersByStudent[] = useMemo(() => {
    const all = answersByClasses
      .map(k => k.answers.map(a => a.student.id))
      .flat();
    const studentIds = Array.from(new Set([...all]));
    return studentIds.map(studentId => {
      const klass = answersByClasses.find(k =>
        k.answers.find(a => a.student.id === studentId),
      )!;
      const answer = klass.answers.find(a => a.student.id === studentId);
      const student = answer?.student;
      const questionAnswers =
        answer?.one_page_portfolio_assessments_question_answers;

      return {
        student,
        nameOpened: klass.name_opened,
        classFullName: klass.full_name,
        questionAnswers: questionAnswers ?? [],
        index: answer?.index,
        haveAnswers: answer?.have_answers,
      };
    });
  }, [answersByClasses]);

  return (
    <div className="d-flex h-100">
      <div className={styles.body}>
        <ul
          className={clsx("nav nav-pills", styles.tabs)}
          id="pills-tab"
          role="tablist"
        >
          <li className="nav-item">
            <a
              className="active"
              data-bs-toggle="pill"
              href="#pills-class"
              role="tab"
              aria-controls="pills-class"
              aria-selected="true"
            >
              クラスの回答
            </a>
          </li>
          <li className="nav-item">
            <a
              data-bs-toggle="pill"
              href="#pills-group"
              role="tab"
              aria-controls="pills-group"
              aria-selected="false"
            >
              グループの回答
            </a>
          </li>
          <li className="nav-item">
            <a
              data-bs-toggle="pill"
              href="#pills-other-school"
              role="tab"
              aria-controls="pills-other-school"
              aria-selected="false"
            >
              他校の回答
            </a>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-class"
            role="tabpanel"
            aria-labelledby="pills-class-tab"
          >
            <ClassAnswers
              answersByStudents={answersByStudents}
              answersByClasses={answersByClasses}
              classList={classList}
              classes={classes}
              changeNameOpenClose={changeNameOpenClose}
            />
          </div>
          <div
            className="tab-pane fade"
            id="pills-group"
            role="tabpanel"
            aria-labelledby="pills-group-tab"
          >
            <GroupAnswers
              groups={groups}
              classList={classList}
              answersByStudents={answersByStudents}
              setShowModalEditGroupClass={setShowModalEditGroupClass}
            />
          </div>
          <div
            className="tab-pane fade"
            id="pills-other-school"
            role="tabpanel"
            aria-labelledby="pills-group-tab"
          >
            <OtherSchoolAnswers
              answersOtherSchoolsByClasses={answersOtherSchoolsByClasses}
            />
          </div>
        </div>
      </div>
      {showModalEditGroupClass && (
        <ModalEditGroupClass
          classIDs={classList}
          onClose={() => setShowModalEditGroupClass(false)}
        />
      )}
    </div>
  );
};
export default BAWorkAnswerList;
